import { render } from "./VueTypeaheadBootstrap.vue?vue&type=template&id=31647657&scoped=true"
import script from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js"
export * from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js"

import "./VueTypeaheadBootstrap.vue?vue&type=style&index=0&id=31647657&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31647657"]])

export default __exports__